export default function filterByReference(arr1, arr2) {
  const content = arr1.filter((el) => {
    return !arr2.find((element) => {
      return element.uuid === el.uuid
    })
  })
  return content
}
